import Pets from './Pets';

export default Pets;
